"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualMotorCommands = void 0;
var HandleEditPhoneNumberPopupCommand_1 = require("./HandleEditPhoneNumberPopupCommand");
var RemoveDriverCommand_1 = require("./RemoveDriverCommand");
var LoadVehicleDriversCommand_1 = require("./LoadVehicleDriversCommand");
var GetBrandNameCommand_1 = require("./GetBrandNameCommand");
var PresetInteractionCommand_1 = require("./PresetInteractionCommand");
var addAnnualMotorCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "handleEditPhoneNumberPopup",
        component: HandleEditPhoneNumberPopupCommand_1.HandleEditPhoneNumberPopupCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeDriver",
        component: RemoveDriverCommand_1.RemoveDriverCommand
    });
    extensions.journeyComponents.addCommand({
        id: "loadVehicleDrivers",
        component: LoadVehicleDriversCommand_1.LoadVehicleDriversCommand
    });
    extensions.journeyComponents.addCommand({
        id: "getBrandName",
        component: GetBrandNameCommand_1.GetBrandNameCommand
    });
    extensions.journeyComponents.addCommand({
        id: "presetInteraction",
        component: PresetInteractionCommand_1.PresetInteractionCommand
    });
};
exports.addAnnualMotorCommands = addAnnualMotorCommands;
//# sourceMappingURL=index.js.map